<template>
  <div class="o-metal-prices-container" v-show="pricesLoaded">
    <div class="o-metal-prices">
      <span class="flex">Spotpris</span>
      <div class="price-wrapper flex" v-for="(price, idx) in prices" :key="idx">
        <span class="price-name">{{ price.name }}</span>
        <span class="price">{{ formatPrice(price.price) }}</span>
        <span class="currency-unit">{{ price.currency }} / {{ price.unit }}</span>
        <span v-if="price.percentChange == 0" class="neutral-percentage">
          {{ price.percentChange }}%
        </span>
        <span v-else :class="[price.percentChange > 0 ? 'up-percentage' : 'down-percentage']" class="flex">
          <span v-if="price.percentChange > 0" class="arrow-icon">▲</span>
          <span v-else class="arrow-icon">▼</span>
          <span v-if="price.percentChange > 0">+</span>{{ price.percentChange }}%
        </span>
      </div>
      <button class="currency-swap" @click="swapCurrency" :title="`Switch to ${nextCurrency}`">{{ nextCurrency }}</button>
    </div>
  </div>
</template>

<script>
const API_URL = 'https://frontend-api.karasmussen.vpprod.no/api/ext/metal-prices/list';

const METAL_NAMES = {
  XAU: 'Gull',
  XAG: 'Sølv',
  XPT: 'Platina',
  XPD: 'Palladium',
};

const PRICE_TYPE = 'askPrice';

export default {
  name: "MetalPricesShortcode",
  data() {
    return {
      prices: [],
      allPrices: [],
      pricesLoaded: false,
      currentCurrency: 'NOK',
      countryCurrency: 'NOK',
      metalPriceInterval: null,
    };
  },
  computed: {
    nextCurrency() {
      return this.currentCurrency === this.countryCurrency ? 'USD' : this.countryCurrency;
    },
  },
  methods: {
    formatPrice(price) {
      if (typeof price === 'string') price = parseFloat(price);
      return price.toLocaleString('en').replace(/,/g, ' ');
    },
    fetchMetalPrices() {
      fetch(API_URL)
        .then(function(res) { return res.json(); })
        .then((data) => {
          if (data.code === 200 && data.result && data.result.list) {
            this.allPrices = data.result.list;
            this.setMetalPrices();
          }
        })
        .catch(() => {});
    },
    setMetalPrices() {
      const currency = this.currentCurrency;
      const filterUnit = currency === this.countryCurrency ? 'g' : 'oz';
      this.prices = [];
      for (const code in METAL_NAMES) {
        const item = this.allPrices.find(
          p => p.currency === currency && p.metal === code && p.unit === filterUnit
        );
        if (!item) continue;

        let price = item[PRICE_TYPE];
        if (!price) continue;

        let { unit, metal } = item;

        // Silver in non-USD: show per kg
        if (metal === 'XAG' && unit === 'g') {
          price = price * 1000;
          unit = 'kg';
        }

        this.prices.push({
          name: METAL_NAMES[metal],
          price: parseFloat(price.toFixed(2)),
          currency,
          unit,
          percentChange: item.percentageChange,
        });
      }
      this.pricesLoaded = true;
    },
    swapCurrency() {
      this.currentCurrency = this.nextCurrency;
      this.setMetalPrices();
    }
  },
  mounted() {
    this.fetchMetalPrices();
    this.metalPriceInterval = setInterval(this.fetchMetalPrices, 1000 * 30);
  },
  beforeDestroy() {
    clearInterval(this.metalPriceInterval);
  },
};
</script>

<style scoped>
.o-metal-prices-container {
  background-color: #1a1a1a;
  border-top: 1px solid #b8975a;
  position: relative;
}

.o-metal-prices {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  gap: 4px;
  color: white;
  padding: 8px 0;
  margin-right: 64px;
  line-height: 1.5em;
  font-weight: 400;
}

@media (min-width: 1024px) {
  .o-metal-prices {
    margin-right: 0;
    max-width: 77.5rem;
    margin-left: auto;
    margin-right: auto;
  }
}

.price-wrapper {
  display: flex;
  margin-left: 4px;
  align-items: baseline;
}

.currency-unit {
  font-size: 0.75rem;
  font-weight: 300;
}

.price-name {
  font-weight: 700;
}

.price {
  font-weight: 600;
  margin-left: 2px;
}

.up-percentage {
  border: 1px solid #39dea8;
  color: #39dea8;
  margin-left: 2px;
  padding: 0 4px;
  border-radius: 12px;
}

.down-percentage {
  border: 1px solid #f8605f;
  color: #f8605f;
  margin-left: 2px;
  padding: 0 4px;
  border-radius: 12px;
}

.neutral-percentage {
  border: 1px solid #39dea8;
  color: #9ca3af;
  margin-left: 2px;
  padding: 0 4px;
  border-radius: 12px;
}

.flex {
  display: flex;
  gap: 4px;
  align-items: baseline;
}

.currency-swap {
  display: flex;
  align-items: center;
  background-color: #b8975a;
  color: black;
  text-decoration: underline;
  font-weight: 600;
  position: absolute;
  cursor: pointer;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 16px;
  border: none;
  box-shadow: -7px 0 7px -3px #111;
}

@media (min-width: 1024px) {
  .currency-swap {
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.arrow-icon {
  width: 9px;
  height: 9px;
  font-size: 9px;
  line-height: 1;
}
</style>